import $ from 'jquery';
import { getCookie } from './util/cookie';
import { dataSend } from './model/dataSend';
import { VisitList } from './model/VisitList';
import { dataUser } from './model/dataUser';
import { Email } from './model/Email';


const apiurl = process.env.API_BASE_URL;
const apiurl2 = process.env.API_BASE_URL2;

// Token 取得
const token = getCookie('loginToken') as string;

// ログイン
export const loginJqXHR = (email: string, password: string) => {
  return $.ajax(`${apiurl2}/gift/auth/login`, {
    type: 'POST',
    data:{
      email : email,
      password: password
    },
    headers: {
      Accept: 'application/json',
    },
  });
};

// 認証ユーザー情報 取得
export const getUserJqXHR = () => {
  const lang = localStorage.getItem('lang') ?? 'ja';
  return $.ajax(`${apiurl}/gift/user`, {
    type: 'GET',
    data: {
      lang: lang,
    },
    headers: {
      Accept: 'application/json',
      Authorization: `${token}`,
    },
  });
};

// ログアウト
export const logoutJqXHR = () => {
  return $.ajax(`${apiurl}/gift/auth/logout`, {
    type: 'POST',
    headers: {
      Accept: 'application/json',
      Authorization: `${token}`,
    },
  });
};

// 認証ユーザーの展示会（登録・未登録）情報 取得
export const getMypageShowJqXHR = () => {
  const lang = localStorage.getItem('lang') ?? 'ja';
  return $.ajax(`${apiurl}/gift/registration/mypage-shows`, {
    type: 'GET',
    data: {
      lang: lang,
    },
    headers: {
      Accept: 'application/json',
      Authorization: `${token}`,
    },
  });
};

// 都道府県コードと都道府県名の一覧を取得
export const getPrefecturesJqXHR = () => {
  const lang = localStorage.getItem('lang') ?? 'ja';
  return $.ajax(`${apiurl}/gift-net/customer/users/inquiry/prefectures`, {
    type: 'GET',
    data: {
      lang: lang,
    },
    headers: {
      Accept: 'application/json',
    },
  });
};

// 業種カテゴリーの一覧を取得
export const getIndustrieCategorysJqXHR = () => {
  const lang = localStorage.getItem('lang') ?? 'ja';
  return $.ajax(`${apiurl}/gift-net/customer/users/inquiry/industrieCategorys`, {
    type: 'GET',
    data: {
      lang: lang,
    },
    headers: {
      Accept: 'application/json',
    },
  });
};

// 業種の一覧を取得
export const getIndustriesJqXHR = (index? : number) => {
  const lang = localStorage.getItem('lang') ?? 'ja';
  const category_code = (index !== undefined) ? index : "";
  return $.ajax(`${apiurl}/gift-net/customer/users/inquiry/industries`, {
    type: 'GET',
    data: {
      lang: lang,
      category_code: category_code,
    },
    headers: {
      Accept: 'application/json',
    },
  });
};

// 主力商品カテゴリーの一覧を取得
export const getMainItemCategorysJqXHR = () => {
  const lang = localStorage.getItem('lang') ?? 'ja';
  return $.ajax(`${apiurl}/gift-net/customer/users/inquiry/mainItemCategorys`, {
    type: 'GET',
    data: {
      lang: lang,
    },
    headers: {
      Accept: 'application/json',
    },
  });
};

// 主力商品の一覧を取得
export const getMainItemsJqXHR = (index? : number) => {
  const lang = localStorage.getItem('lang') ?? 'ja';
  const category_code = (index !== undefined) ? index : "";
  return $.ajax(`${apiurl}/gift-net/customer/users/inquiry/mainItems`, {
    type: 'GET',
    data: {
      lang: lang,
      category_code: category_code,
    },
    headers: {
      Accept: 'application/json',
    },
  });
}; 

// 職種の一覧を取得
export const getOccupationsJqXHR = () => {
  const lang = localStorage.getItem('lang') ?? 'ja';
  return $.ajax(`${apiurl}/gift-net/customer/users/inquiry/occupations`, {
    type: 'GET',
    data: {
      lang: lang,
    },
    headers: {
      Accept: 'application/json',
    },
  });
};

// 購買決定権の一覧を取得
export const getRolesJqXHR = () => {
  const lang = localStorage.getItem('lang') ?? 'ja';
  return $.ajax(`${apiurl}/gift-net/customer/users/inquiry/purchasingPowers`, {
    type: 'GET',
    data: {
      lang: lang,
    },
    headers: {
      Accept: 'application/json',
    },
  });
};

// 購買決定額の一覧を取得
export const getPriceJqXHR = () => {
  const lang = localStorage.getItem('lang') ?? 'ja';
  return $.ajax(`${apiurl}/gift-net/customer/users/inquiry/budgetValues`, {
    type: 'GET',
    data: {
      lang: lang,
    },
    headers: {
      Accept: 'application/json',
    },
  });
};

// 居住地域の一覧を取得
export const getAreaJqXHR = () => {
  const lang = localStorage.getItem('lang') ?? 'ja';
  return $.ajax(`${apiurl}/gift-net/customer/users/inquiry/areas`, {
    type: 'GET',
    data: {
      lang: lang,
    },
    headers: {
      Accept: 'application/json',
    },
  });
};

// 国の一覧を取得
export const getCountriesJqXHR = () => {
  const lang = localStorage.getItem('lang') ?? 'ja';
  return $.ajax(`${apiurl}/gift-net/customer/users/inquiry/countries`, {
    type: 'GET',
    data: {
      lang: lang,
    },
    headers: {
      Accept: 'application/json',
    },
  });
};

// 展示会一覧を取得
export const getShowsJqXHR = () => {
  const lang = localStorage.getItem('lang') ?? 'ja';
  return $.ajax(`${apiurl}/gift/registration/shows`, {
    type: 'GET',
    data: {
      lang: lang,
    },
    headers: {
      Accept: 'application/json',
    },
  });
};

// 次回出展検討の一覧を取得
export const getNextjoinsJqXHR = () => {
  const lang = localStorage.getItem('lang') ?? 'ja';
  return $.ajax(`${apiurl}/gift/registration/nextJoin`, {
    type: 'GET',
    data: {
      lang: lang,
    },
    headers: {
      Accept: 'application/json',
    },
  });
};

// 来場目的の一覧を取得
export const getPurposeOptionsJqXHR = () => {
  const lang = localStorage.getItem('lang') ?? 'ja';
  return $.ajax(`${apiurl}/gift/registration/purpose_option`, {
    type: 'GET',
    data: {
      lang: lang,
    },
    headers: {
      Accept: 'application/json',
    },
  });
};

// どこで知りましたか
export const getRegistRouteJqXHR = () => {
  const lang = localStorage.getItem('lang') ?? 'ja';
  return $.ajax(`${apiurl}/gift/registration/regist_route`, {
    type: 'GET',
    data: {
      lang: lang,
    },
    headers: {
      Accept: 'application/json',
    },
  });
};

// 招待状の種類
export const getInvitationTypeJqXHR = () => {
  const lang = localStorage.getItem('lang') ?? 'ja';
  return $.ajax(`${apiurl}/gift/registration/invitation_types`, {
    type: 'GET',
    data: {
      lang: lang,
    },
    headers: {
      Accept: 'application/json',
    },
  });
};

// コードチェック取得
export const checkvipcodeJqXHR = (vipcode: string) => {
  const lang = localStorage.getItem('lang') ?? 'ja';
  return $.ajax(`${apiurl}/gift/check/vip`, {
    method: 'POST',
    contentType: 'application/json; charset=UTF-8',
    data: JSON.stringify({
      // code
      vipCode : vipcode
    }),
    headers: {
      Accept: 'application/json',
    },
  });
};

// メールアドレスチェック
export const checkEmailJqXHR = (email: string) => {
  return $.ajax(`${apiurl}/gift/check/email`, {
    method: 'POST',
    contentType: 'application/json; charset=UTF-8',
    data: JSON.stringify({
      // code
      email : email
    }),
    headers: {
      Accept: 'application/json',
    },
  });
};

// 新規会員登録
export const dataSendJqXHR = (dataSend: dataSend) => {
  const lang = localStorage.getItem('lang') ?? 'ja';
  const share_code = localStorage.getItem('share_code');
  return $.ajax(`${apiurl}/gift/registration/new_registration`, {
    method: 'POST',
    contentType: 'application/json; charset=UTF-8',
    data: JSON.stringify({
      // code 後々画面データをはめる
      sms_token: dataSend.smsToken,
      procFlag:dataSend.procFlag,
      userFlag:dataSend.userFlag,
      code: dataSend.code,
      lang:dataSend.lang,
      share_code:dataSend.share_code,
      email: dataSend.email,
      password: dataSend.password,
      familyName: dataSend.familyName,
      givenName: dataSend.givenName,
      familyNameKana: dataSend.familyNameKana,
      givenNameKana: dataSend.givenNameKana,
      emergencyContactValue: dataSend.emergencyContactValue,
      companyName: dataSend.companyName,
      companyNameKana: dataSend.companyNameKana,
      department: dataSend.department,
      position: dataSend.position,
      areaIndex: dataSend.areaIndex,
      countryIndex: dataSend.countryIndex,
      zipCode: dataSend.zipCode,
      prefectureIndex: dataSend.prefectureIndex,
      city: dataSend.city,
      houseNumber: dataSend.houseNumber,
      building: dataSend.building,
      phoneNumber: dataSend.phoneNumber,
      industryValueIndex: dataSend.industryValueIndex,
      industryOtherText: dataSend.industryOtherText,
      mainItemValueIndex: dataSend.mainItemValueIndex,
      mainItemOtherText: dataSend.mainItemOtherText,
      occupationIndex: dataSend.occupationIndex,
      decisionRightValueIndex: dataSend.decisionRightValueIndex,
      decisionPriceValueIndex: dataSend.decisionPriceValueIndex,
      nextJoinId: dataSend.nextJoinId,
      purposeCode: dataSend.purposeCode,
      foreignItemIndex: dataSend.foreignItemIndex,
      invitation_type: dataSend.invitationType,
      //hopeEmailPush: dataSend.hopeEmailPush,
      //mailGuidanceIndex: dataSend.mailGuidanceIndex,
      subscribeIndex:dataSend.subscribeIndex,
      applyList: dataSend.applyList,
      route_id: dataSend.route_id,
      tenji_key: dataSend.tenji_key
    }),
    headers: {
      Accept: 'application/json',
    },
  });
};

// 会員情報変更
export const dataUserJqXHR = (dataUser: dataUser) => {
  const lang = localStorage.getItem('lang') ?? 'ja';
  return $.ajax(`${apiurl}/gift/member/invitation/update`, {
    method: 'POST',
    contentType: 'application/json; charset=UTF-8',
    data: JSON.stringify({
      // code 後々画面データをはめる
      procFlag:dataUser.procFlag,
      lang:dataUser.lang,
      emergencyContactValue: dataUser.emergencyContactValue,
      companyName: dataUser.companyName,
      companyNameKana: dataUser.companyNameKana,
      department: dataUser.department,
      position: dataUser.position,
      areaIndex: dataUser.areaIndex,
      countryIndex: dataUser.countryIndex,
      zipCode: dataUser.zipCode,
      prefectureIndex: dataUser.prefectureIndex,
      city: dataUser.city,
      houseNumber: dataUser.houseNumber,
      building: dataUser.building,
      phoneNumber: dataUser.phoneNumber,
      industryCategoryIndex: dataUser.industryCategoryIndex,
      industryValueIndex: dataUser.industryValueIndex,
      industryOtherText: dataUser.industryOtherText,
      mainItemCategoryIndex: dataUser.mainItemCategoryIndex,
      mainItemValueIndex: dataUser.mainItemValueIndex,
      mainItemOtherText: dataUser.mainItemOtherText,
      occupationIndex: dataUser.occupationIndex,
      decisionRightValueIndex: dataUser.decisionRightValueIndex,
      decisionPriceValueIndex: dataUser.decisionPriceValueIndex,
      foreignItemIndex: dataUser.foreignItemIndex,
      hopeEmailPush: dataUser.hopeEmailPush,
      mailGuidanceIndex: dataUser.mailGuidanceIndex,
      subscribeIndex:dataUser.subscribeIndex,
    }),
    headers: {
      Accept: 'application/json',
      Authorization: `${token}`,
    },
  });
};

// ご来場予定の変更
export const setVisitListJqXHR = (VisitList: VisitList) => {
  const lang = localStorage.getItem('lang') ?? 'ja';
  return $.ajax(`${apiurl}/gift/member/visitlist/update`, {
    method: 'POST',
    contentType: 'application/json; charset=UTF-8',
    data: JSON.stringify({
      // code 後々画面データをはめる
      procFlag:VisitList.procFlag,
      lang:VisitList.lang,
      nextJoinId: VisitList.nextJoinId,
      purposeOptionsIndex: VisitList.purposeOptionsIndex,
      applyList: VisitList.applyList
    }),
    headers: {
      Accept: 'application/json',
      Authorization: `${token}`,
    },
  });
};

// ご来場予定の削除
export const deleteVisitListJqXHR = (show_code: string) => {
  return $.ajax(`${apiurl}/gift/member/willvisit/${show_code}/delete`, {
    type: 'DELETE',
    headers: {
      Accept: 'application/json',
      Authorization: `${token}`,
    },
  });
};

// メールアドレスの変更
export const postEmailJqXHR = (email: string) => {
  return $.ajax(`${apiurl}/gift/email/sendEmail`, {
    method: 'POST',
    contentType: 'application/json; charset=UTF-8',
    data: JSON.stringify({
      // code
      email : email
    }),
    headers: {
      Accept: 'application/json',
      Authorization: `${token}`,
    },
  });
};

// パスワードの変更
export const postPasswordJqXHR = (password: string) => {
  return $.ajax(`${apiurl}/gift/user/update`, {
    method: 'POST',
    contentType: 'application/json; charset=UTF-8',
    data: JSON.stringify({
      // code
      password : password
    }),
    headers: {
      Accept: 'application/json',
      Authorization: `${token}`,
    },
  });
};

// パスワード再設定の送信
export const postPasswordSendEmailJqXHR = (email: string) => {
  return $.ajax(`${apiurl}/gift/password/sendEmail`, {
    type: 'POST',
    data:{
      email : email
    },
    headers: {
      Accept: 'application/json',
    },
  });
};

// パスワード再設定
export const postPasswordResetJqXHR = (email: string, password: string) => {
  console.log(email,password);
  return $.ajax(`${apiurl}/gift/password/reset`, {
    type: 'POST',
    data:{
      email : email,
      password : password
    },
    headers: {
      Accept: 'application/json',
    },
  });
};

// 検討リスト一覧 取得
export const getConsiderationsJqXHR = () => {
  return $.ajax(`${apiurl}/gift-net/customer/considerations`, {
    type: 'GET',
    headers: {
      Accept: 'application/json',
      Authorization: `${token}`,
    },
  });
};

// いいね一覧 取得
export const getfavoritesJqXHR = () => {
  let lang = localStorage.getItem('lang') ?? 'ja';
  if( lang == 'cn' ) lang = 'en';//中国語非対応でとりあえずenにする　※対応したら削除すること！
  return $.ajax(`${apiurl}/gift-net/customer/favorites`, {
    type: 'GET',
    data: {
      lang: lang,
    },
    headers: {
      Accept: 'application/json',
      Authorization: `${token}`,
    },
  });
};

// 名刺交換一覧 取得
export const getCardExchangesJqXHR = () => {
  return $.ajax(`${apiurl}/gift-net/search/card_exchanges`, {
    type: 'GET',
    headers: {
      Accept: 'application/json',
      Authorization: `${token}`,
    },
  });
};

// 広告 取得
export const getAdJqXHR = () => {
  return $.ajax(`${apiurl}/gift-net/search/get/ad`, {
    type: 'GET',
    headers: {
      Accept: 'application/json',
    },
  });
};

// 広告をクリックする時叩く
export const postAdJqXHR = (id: number) => {
  return $.ajax(`${apiurl}/gift-net/search/click/ad/${id}`, {
    type: 'POST',
    headers: {
      Accept: 'application/json',
    },
  });
};

// ビジネスガイド社からのお知らせ　取得 (旧特集)
export const getSfJqXHR = () => {
  return $.ajax(`${apiurl}/gift-net/search/get/sf`, {
    type: 'GET',
    headers: {
      Accept: 'application/json',
    },
  });
};

// ビジネスガイド社からのお知らせをクリックする時叩く (旧特集)
export const postSfJqXHR = (id: number) => {
  return $.ajax(`${apiurl}/gift-net/search/click/sf/${id}`, {
    type: 'POST',
    headers: {
      Accept: 'application/json',
    },
  });
};

// 産地商談会取得
export const getMgJqXHR = () => {
  const lang = localStorage.getItem('lang') ?? 'ja';
  return $.ajax(`${apiurl}/gift-net/search/seto/localShow`, {
    type: 'GET',
    data: {
      lang: lang,
    },
    headers: {
      Accept: 'application/json',
    },
  });
};

// 検討リストに追加
export const postConsiderJqXHR = (shop_id: string) => {
  return $.ajax(`${apiurl}/gift-net/customer/shops/${shop_id}/considerations`, {
    type: 'POST',
    headers: {
      Accept: 'application/json',
      Authorization: `${token}`,
    },
  });
};

// 検討リストから削除
export const deleteConsiderJqXHR = (shop_id: string) => {
  return $.ajax(`${apiurl}/gift-net/customer/shops/${shop_id}/considerations`, {
    type: 'DELETE',
    headers: {
      Accept: 'application/json',
      Authorization: `${token}`,
    },
  });
};

// いいねに追加
export const postLikeJqXHR = (shop_id: string, product_id: string) => {
  return $.ajax(
    `${apiurl}/gift-net/customer/shops/${shop_id}/products/${product_id}/favorites`,
    {
      type: 'POST',
      headers: {
        Accept: 'application/json',
        Authorization: `${token}`,
      },
    }
  );
};

// いいねから削除
export const deleteLikeJqXHR = (shop_id: string, product_id: string) => {
  return $.ajax(
    `${apiurl}/gift-net/customer/shops/${shop_id}/products/${product_id}/favorites`,
    {
      type: 'DELETE',
      headers: {
        Accept: 'application/json',
        Authorization: `${token}`,
      },
    }
  );
};

export const sendPhoneNumberXHR = (phoneNumber: string) => {
  const lang = localStorage.getItem("lang") ?? "ja";
  return $.ajax(`${apiurl}/gift/registration/send/code?lang=${lang}`, {
    method: "POST",
    contentType: "application/json; charset=UTF-8",
    data: JSON.stringify({
      mobile: phoneNumber,
    }),
    headers: {
      Accept: "application/json",
    },
  });
};

export const sendEmailAddressXHR = (emailAddress: string) => {
  const lang = localStorage.getItem("lang") ?? "ja";
  return $.ajax(`${apiurl}/gift/registration/send/code?lang=${lang}`, {
    method: "POST",
    contentType: "application/json; charset=UTF-8",
    data: JSON.stringify({
      email: emailAddress,
    }),
    headers: {
      Accept: "application/json",
    },
  });
};

export const sendOTPNumberXHR = (mobile: string, sms_code: string, sms_token: string) => {
  return $.ajax(
    `${apiurl}/gift/registration/check/code`,
    {
      method: 'POST',
      contentType: 'application/json; charset=UTF-8',
      data: JSON.stringify({
        mobile, sms_code, sms_token
      }),
      headers: {
        Accept: 'application/json',
      },
    }
  );
};

export const sendEmailOTPNumberXHR = (email: string, sms_code: string, sms_token: string) => {
  return $.ajax(
    `${apiurl}/gift/registration/check/code`,
    {
      method: 'POST',
      contentType: 'application/json; charset=UTF-8',
      data: JSON.stringify({
        email, sms_code, sms_token
      }),
      headers: {
        Accept: 'application/json',
      },
    }
  );
};


